import { render, staticRenderFns } from "./medicion-prevalencia-ver.vue?vue&type=template&id=2a3c3a3b&scoped=true&"
import script from "./medicion-prevalencia-ver.vue?vue&type=script&lang=js&"
export * from "./medicion-prevalencia-ver.vue?vue&type=script&lang=js&"
import style0 from "./medicion-prevalencia-ver.vue?vue&type=style&index=0&id=2a3c3a3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3c3a3b",
  null
  
)

export default component.exports